export enum FollowUpSurveyInstance {    
    Month6 = 0,
    Year1 = 1,
    Year2 = 2,
    Year3 = 3,
    Year4 = 4,
    Year5 = 5,
    Year6 = 6,
    Year7 = 7,
    Year8 = 8,
    Year9 = 9,
    Year10 = 10,
    Year11 = 11,
    Year12 = 12,
    Year13 = 13,
    Year14 = 14,
    Year15 = 15,
    Year16 = 16,
    Year17 = 17,
    Year18 = 18,
    Year19 = 19,
    Year20 = 20,
    Year21 = 21,
    Year22 = 22,
    Year23 = 23,
    Year24 = 24,
    Year25 = 25,
    Year26 = 26,
    Year27 = 27,
    Year28 = 28,
    Year29 = 29,
    Year30 = 30
}